<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card grid-list-md>
      <ModelTitle title="Edit Student" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-text-field outlined autofocus dense hide-details v-model="Student.firstName" label="First Name">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field outlined dense hide-details v-model="Student.lastName" label="Last Name"></v-text-field>
          </v-col>
          <!-- <v-col cols="12" sm="9">
            <v-text-field
              outlined
              :hide-details="nameErrors.length === 0"
              dense
              autofocus
              :error-messages="nameErrors"
              v-model="name"
              label="Name"
            ></v-text-field>
          </v-col> -->
          <v-col cols="12" sm="6" md="6">
            <v-select dense hide-details :items="['male', 'female']" label="Gender" v-model="Student.gender" outlined>
            </v-select>
            <!-- <v-text-field
              outlined
              :hide-details="nameErrors.length === 0"
              dense
              autofocus
              :error-messages="nameErrors"
              v-model="Student.name"
              label="Name"
            ></v-text-field> -->
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field outlined dense hide-details v-model="Student.phoneNumber" label="Phone Number"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field outlined dense hide-details v-model="Student.email" label="Email Address"></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-text-field outlined hide-details dense v-model="Student.reference" label="Reference"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12">
            <v-textarea outlined dense hide-details auto-grow v-model="Student.description"
              :label="$t('labels.description')"></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- <v-list v-if="Student">
        <v-subheader>Classes</v-subheader>
        <template v-for="(item, index) in Classes">
          <v-list-item :key="index" class="text-capitalize">
            <v-list-item-content>
              <v-list-item-title>{{ item.Class.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.parentPay | currency }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-row justify="end">
                <v-col class="shrink">
                  <v-btn icon @click="editFeeOpen(item)">
                    <v-icon color="grey lighten-1">mdi-pencil</v-icon>
                  </v-btn>

                </v-col>
                <v-col class="shrink">
                  <v-btn icon @click="deleteStudent(Student.ClassStudents[index])">
                    <v-icon color="red lighten-1">mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item-action>
          </v-list-item>

        </template>
      </v-list>


      <v-list v-if="Student">
        <v-subheader>Teacher</v-subheader>
        <template v-for="(item, index) in Teachers">
          <v-list-item :key="index" class="text-capitalize">
            <v-list-item-content>
              <v-list-item-title>{{ item.Teacher.name }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-row justify="end">
                <v-col class="shrink">

                </v-col>
                <v-col class="shrink">
                  <v-btn icon @click="removeTeacher(Teachers[index])">
                    <v-icon color="red lighten-1">mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item-action>
          </v-list-item>

        </template>
      </v-list> -->

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="accent" :loading="loading" dark @click="submit()">Update</v-btn>
      </v-card-actions>
    </v-card>
    <!-- <EditFee :editDialog="feeDialog" @close="feeDialog = false" @submit="editFeeSubmit" :editStudent="selectedStudent">
    </EditFee> -->
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import studentService from "@/modules/Student/service.js";
// import classStudentService from "@/modules/Student/service.js"

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");
// const EditFee = () => import("@/modules/Student/components/EditFee.vue");


export default {
  name: "update-Student",
  props: {
    editDialog: {
      default: false,
    },
    editStudent: {
      type: Object,
    },
  },
  data() {
    return {
      Teachers: [],
      feeDialog: false,
      loading: false,
      dialog: false,
      Classes: [],
      selectedStudent: null,
      selectedTeacher: null,
      Student: {
        name: null,
        email: null,
        gender: "male",
        phoneNumber: null,
        reference: null,
        note: null,
        fee: 0,
        discount: 0,
        sponsor: 0,
        parentPay: 0,
      },
      fee: 0,
      discount: 0,
      sponsor: 0,
      parentPay: 0,
    };
  },
  mixins: [validationMixin],
  validations: {
    Student: {
      firstName: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    balancePayment() {
      return this.fee - this.discount - this.sponsor;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.Student.firstName.$dirty) return errors;
      if (!this.$v.Student.firstName.required)
        errors.push("First name is required");
      return errors;
    },
  },
  // components: {
  //   EditFee,
  // },
  watch: {
    editDialog(val) {
      // console.log('editStudenteditStudent', this.editStudent)
      this.Student = this.editStudent;
      this.dialog = val;
      // this.getClasses();
      // console.log('Student', this.Student)
      // this.getTeacher();
    },
  },
  methods: {
    editFeeSubmit() {
      this.$emit("submit");
    },
    editFeeOpen(item) {
      // console.log('studne', this.editStudent.ClassStudents[index])
      this.selectedStudent = item
      this.feeDialog = !this.feeDialog
    },
    removeTeacher(obj) {
      console.log('removeTeacher obj', obj)
      this.$swal({
        title: "Are you sure?",
        text: `You want to remove ${this.Student.fullName} from ${obj.Teacher.name} Class`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          studentService.removeStudentFromTeacher(obj.id).then((response) => {
            if (response.data) {
              this.$swal("Remove!", "Teacher has been Remove.", "success");
              this.$emit("submit");
            }
          });
        }
      });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Student = {
        name: null,
        email: null,
        gender: "male",
        phoneNumber: null,
        reference: null,
        note: null,
        fee: 0,
        discount: 0,
        parentPay: 0,
        sponsor: 0,
      };
      this.fee = 0;
      this.discount = 0;
      this.sponsor = 0;
      this.parentPay = 0;
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;

        return studentService
          .update(this.Student.id, this.Student)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Student is updated",
                });
              this.loading = false;
              this.$emit("submit", {student: this.Student});
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped>
</style>
